import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";

@Component({
  selector: 'app-session-resources',
  templateUrl: './session-resources.component.html',
  styleUrls: ['./session-resources.component.css']
})
export class SessionResourcesComponent {
  @Input() data;

  categoryHexColorCode = [
    '#800080',
    '#FF00FF',
    '#000080',
    '#0000FF',
  ];

  constructor(private router: Router) {
  }

  navigateToDetails() {
    const urlPrefix = this.router.url.split('/')[1];
    const url = `/${urlPrefix}/resource-hub/resource-details/${this.data?.id}/${this.data?.slug}`;
    window.open(url, '_blank');
  }
}
